export default {
  salons: {
    label: 'Salons',
    actions: ({ siteId, doc }) => [
      {
        id: 'dashboard',
        label: 'Dashboard',
        link: `/${siteId}/salondb/${encodeURIComponent(doc._id)}`,
      },
      {
        id: 'orders',
        label: 'Orders',
        link: `/${siteId}/salondb/${encodeURIComponent(doc._id)}`,
      },
      {
        id: 'sales',
        label: 'myTracker',
        link: `/${siteId}/mytracker?filters%5B0%5D%5Bkey%5D=distributorsales.salon&filters%5B0%5D%5Boperator%5D=idIs&filters%5B0%5D%5Bvalue%5D=${encodeURIComponent(
          doc._id,
        )}&filters%5B0%5D%5Blabel%5D=${encodeURIComponent(doc.n)}`,
      },
    ],
  },
  masterProducts: {
    label: 'Products',
    actions: ({ siteId, doc }) => [
      {
        id: 'sales',
        label: 'myTracker',
        link: `/${siteId}/mytracker?filters%5B0%5D%5Bkey%5D=distributorsales.master_product&filters%5B0%5D%5Boperator%5D=idIs&filters%5B0%5D%5Bvalue%5D=${encodeURIComponent(
          doc._id,
        )}&filters%5B0%5D%5Blabel%5D=${encodeURIComponent(doc.n)}`,
      },
    ],
  },
  // users: {
  //   label: 'Users',
  //   actions: ({ siteId, doc }) => [],
  // },
  distributors: {
    label: 'Distributors',
    actions: ({ siteId, doc }) => [
      {
        id: 'sales',
        label: 'myTracker',
        link: `/${siteId}/mytracker?filters%5B0%5D%5Bkey%5D=distributorsales.distributor&filters%5B0%5D%5Boperator%5D=idIs&filters%5B0%5D%5Bvalue%5D=${encodeURIComponent(
          doc._id,
        )}&filters%5B0%5D%5Blabel%5D=${encodeURIComponent(doc.n)}`,
      },
    ],
  },
  brands: {
    label: 'Brands',
    actions: ({ siteId, doc }) => [
      {
        id: 'sales',
        label: 'myTracker',
        link: `/${siteId}/mytracker?filters%5B0%5D%5Bkey%5D=masterproducts.brand&filters%5B0%5D%5Boperator%5D=strIdIs&filters%5B0%5D%5Bvalue%5D=${encodeURIComponent(
          doc._id,
        )}&filters%5B0%5D%5Blabel%5D=${encodeURIComponent(doc.n)}`,
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/Search/configs.js